import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import useCreateRegion from './queries/useCreateRegion';

import FormBase from '@/components/forms/new/FormBase';
import {
    breadCrumbTrail,
    addHeader as header,
    initialState,
    regionsAndLocationsPath,
} from './constants';
import RegionNameField from './formFields/RegionNameField';

const RegionAdd = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { darkMode } = useSelector((state) => state.settings);

    const handleBack = () => {
        dispatch({
            type: 'CHANGE_TAB_VIEW',
            payload: { level1: 0, level2: 0 },
        });
        navigate(regionsAndLocationsPath);
    };

    const handleSuccess = (data) => {
        toast.success('Region created successfully!');
        navigate(`/regions-and-locations/regions/edit/${data.id}`);
    };

    const handleError = (error) => {
        console.error('Failed to create region:', error);
        toast.error('Failed to create region. Please try again.');
    };

    const { mutate: createRegion, isPending } = useCreateRegion(
        handleSuccess,
        handleError,
    );

    const finalFormSubmit = async (values) => {
        if (!values.name || values.name.length < 1) {
            console.error('Region name is required');
            return;
        }
        createRegion({ name: values.name });
    };

    const formFields = (errors, touched) => [
        <RegionNameField
            key="name"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    return (
        <FormBase
            isSubmitDisabled={isPending}
            isLoading={isPending}
            breadCrumbTrail={breadCrumbTrail}
            header={header}
            initialValues={initialState}
            finalFormSubmit={finalFormSubmit}
            backLink={handleBack}>
            {({ errors, touched }) => formFields(errors, touched)}
        </FormBase>
    );
};

export default RegionAdd;
